module.exports = __webpack_public_path__ + "img/adventage_bg_desctop.308d18db.png";